import React from 'react';
import ConsultancyStepCard from '../Landpage/components/consultancyStep/ConsultancyStepCard';
import OutlineLightButton from '../Landpage/components/consultancyStep/OutlineLightButton';
import SectionTitle from '../Landpage/components/consultancyStep/SectionTitle';
import consultancyStyles from '../Landpage/components/consultancyStep/consultancyStep.module.css';
import LandingCopyright from '../Landpage/components/landingFaq/LandingCopyright';
import {
  MariMessageBody,
  MariMessageTitle,
} from '../Landpage/components/mariMessage/MariMessageContainer';
import mariMessageStyles from '../Landpage/components/mariMessage/mariMessage.module.css';
import MariPhoto from '../Landpage/components/mariMessage/MariPhoto';
import OnboardingHeroSection from '../Landpage/components/onboardingHero/OnboardingHeroSection';
import WelcomeVideoContainer from '../Landpage/components/welcomeVideo/WelcomeVideoContainer';
import welcomeVideoStyles from '../Landpage/components/welcomeVideo/welcomeVideo.module.css';
import { LANDPAGE_FAQ, LANDPAGE_MARI_MESSAGE } from '../Landpage/landpage.constants';
import {
  CINTA_NATURAL_FINAL_MESSAGE,
  CINTA_NATURAL_HERO,
  CINTA_NATURAL_STEPS,
  CINTA_NATURAL_STEPS_TITLE,
  CINTA_NATURAL_WELCOME_VIDEO,
  type CintaNaturalStep,
} from './cintaNaturalOnboarding.constants';
import styles from './CintaNaturalOnboarding.module.css';

const StepAction: React.FC<{ label: string; href?: string }> = ({ label, href }) => {
  if (href) {
    return (
      <OutlineLightButton medium href={href}>
        {label}
      </OutlineLightButton>
    );
  }

  return (
    <OutlineLightButton medium disabled>
      {label}
    </OutlineLightButton>
  );
};

const Paragraphs: React.FC<{ paragraphs: readonly string[] }> = ({ paragraphs }) => (
  <>
    {paragraphs.map((paragraph) => (
      <p key={paragraph} className={consultancyStyles.descriptionParagraph}>
        {paragraph}
      </p>
    ))}
  </>
);

const ProtocolItems: React.FC<{ items: NonNullable<CintaNaturalStep['items']> }> = ({ items }) => (
  <div className={styles['protocol-list']}>
    {items.map((item) => (
      <div key={item.title} className={styles.protocol}>
        <h3 className={styles['protocol-title']}>{item.title}</h3>
        <Paragraphs paragraphs={item.paragraphs} />
        <div className={styles['protocol-action']}>
          <StepAction label={item.actionLabel} href={item.actionHref} />
        </div>
      </div>
    ))}
  </div>
);

const CintaNaturalWelcomeVideo: React.FC = () => (
  <section className={welcomeVideoStyles.section}>
    <WelcomeVideoContainer
      embedUrl={CINTA_NATURAL_WELCOME_VIDEO.embedUrl}
      title={CINTA_NATURAL_WELCOME_VIDEO.title}
    />
  </section>
);

const CintaNaturalSteps: React.FC = () => (
  <section className={consultancyStyles.section}>
    <SectionTitle>{CINTA_NATURAL_STEPS_TITLE}</SectionTitle>

    <div className={consultancyStyles.stepsStack}>
      {CINTA_NATURAL_STEPS.map((step) => (
        <ConsultancyStepCard
          key={step.id}
          step={`Passo ${step.id}`}
          title={step.title}
          description={<Paragraphs paragraphs={step.paragraphs} />}
          imageSrc={step.imageSrc}
          imageAlt={step.imageAlt}
          imagePosition={step.imagePosition}
          imageObjectPosition={step.imageObjectPosition}
          imageRightCropPx={step.imageRightCropPx}
          actions={
            step.actionLabel
              ? <StepAction label={step.actionLabel} href={step.actionHref} />
              : undefined
          }
        >
          {step.items ? <ProtocolItems items={step.items} /> : null}
        </ConsultancyStepCard>
      ))}
    </div>
  </section>
);

const CintaNaturalFinalMessage: React.FC = () => (
  <section className={mariMessageStyles.section}>
    <div className={mariMessageStyles.container}>
      <MariPhoto src={LANDPAGE_MARI_MESSAGE.imageSrc} alt={LANDPAGE_MARI_MESSAGE.imageAlt} />
      <div className={mariMessageStyles.content}>
        <MariMessageTitle>{CINTA_NATURAL_FINAL_MESSAGE.title}</MariMessageTitle>
        <MariMessageBody paragraphs={CINTA_NATURAL_FINAL_MESSAGE.paragraphs} />
      </div>
    </div>
  </section>
);

const CintaNaturalOnboarding: React.FC = () => (
  <>
    <OnboardingHeroSection copy={CINTA_NATURAL_HERO} />
    <CintaNaturalWelcomeVideo />
    <CintaNaturalSteps />
    <CintaNaturalFinalMessage />
    <LandingCopyright text={LANDPAGE_FAQ.copyright} />
  </>
);

export default CintaNaturalOnboarding;
